import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Col, Row } from 'reactstrap'
import { Fieldset } from 'primereact/fieldset'

import InputGroup from '../../common/InputGroup'
import CustomNumberFormat from '../ClickToCall/ClickToCall'
import InputWithCustomFormat from '../ClickToCall/InputWithCustomFormat'
import { EMAIL, OUT_GOING_CALL } from '../../constants/activityTypes'

const CompleteTaskAdditionalContact = ({ openNextStep }) => {
  const { additionalContactData, contactId } = useSelector((state) => ({
    additionalContactData: state.Task?.otherContactData?.additionalContactData,
    contactId: state.Task.data.contactId,
  }))
  const [collapsed, setCollapsed] = useState(additionalContactData?.length > 1)

  const toggle = () => {
    setCollapsed(!collapsed)
  }

  const handleOpenNextStep = (value, activityType) => {
    if (value) {
      openNextStep(activityType)
    }
  }

  return (
    <Row>
      <Col>
        <Fieldset legend='Additional Contact Info' toggleable collapsed={collapsed} onToggle={toggle}>
          {!additionalContactData || Object.keys(additionalContactData[0]).length === 0
            ? 'There is no additional contacts!'
            : additionalContactData.map((contactData) => (
                <Row className='mt-2' key={contactData.businessPhone}>
                  <Col md='3'>
                    <InputGroup label='Owner Name' disabled value={contactData.contactPerson} />
                  </Col>
                  <Col md='3'>
                    <InputWithCustomFormat
                      name='email'
                      label='Email'
                      value={contactData.email || ''}
                      placeholder='Email'
                      type='text'
                      customIcon='pi-envelope'
                      disabled
                      onClickFunction={() => {
                        contactData.email && window.open(`mailto:${contactData.email}?subject=Email`)
                        handleOpenNextStep(contactData.email, EMAIL)
                      }}
                    />
                  </Col>
                  <Col md='3'>
                    <CustomNumberFormat
                      makeCallOnTaskComplete
                      className={'form-control-sm form-control'}
                      name='businessPhone'
                      label='Business Phone'
                      value={contactData.businessPhone || ''}
                      placeholder='Business Phone'
                      type='tel'
                      disabled
                      format='(999) 999-9999'
                      size={10}
                      contactId={contactId}
                      activityType={OUT_GOING_CALL}
                      customOnClick={() => handleOpenNextStep(contactData.businessPhone, OUT_GOING_CALL)}
                    />
                  </Col>
                  <Col md='3'>
                    <CustomNumberFormat
                      makeCallOnTaskComplete
                      className={'form-control-sm form-control'}
                      name='mobilePhone'
                      label='Mobile Phone'
                      value={contactData.mobilePhone || ''}
                      placeholder='Mobile Phone'
                      type='tel'
                      disabled
                      format='(999) 999-9999'
                      size={10}
                      contactId={contactId}
                      activityType={OUT_GOING_CALL}
                      customOnClick={() => handleOpenNextStep(contactData.mobilePhone, OUT_GOING_CALL)}
                    />
                  </Col>
                </Row>
              ))}
        </Fieldset>
      </Col>
    </Row>
  )
}

export default CompleteTaskAdditionalContact
